/* eslint-disable camelcase */

function formatItems(items) {
    return items.map(({ itemBrand, itemCategoryChild, itemCategoryParent, itemId, itemName, itemPrice }) => ({
        item_name: itemName,
        item_id: itemId,
        item_brand: itemBrand,
        item_parent_reporting_category: itemCategoryParent,
        item_child_reporting_category: itemCategoryChild,
        price: itemPrice.replace(/\$/gi, '')
    }));
}

export function spViewItemList(listName, items) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'sp_view_item_list',
        ecommerce: {
            item_list_name: listName,
            items: formatItems(items)
        }
    });
}

export function spSelectItem(listName, item) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'sp_select_item',
        ecommerce: {
            item_list_name: listName,
            items: formatItems([item])
        }
    });
}